module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeLoading"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://img.chezhentong.com/loading-spokes.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("数据加载中....")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3321db96","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/mb-loading.vue
// module id = 132
// module chunks = 18